import { render, staticRenderFns } from "./Tests.vue?vue&type=template&id=08731eb4&scoped=true&"
import script from "./Tests.vue?vue&type=script&lang=ts&"
export * from "./Tests.vue?vue&type=script&lang=ts&"
import style0 from "./Tests.vue?vue&type=style&index=0&id=08731eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08731eb4",
  null
  
)

export default component.exports